<template>
  <div
    v-click-outside="hideMenu"
    class="roomie-action-menu">
    <button
      v-if="!isInitiallyOpen"
      class="roomie-action-menu__button"
      @click="toggleMenu">
      <RoomieIcon
        v-if="selectedChoice.icon"
        :icon-name="selectedChoice.icon"
        :custom-styles="`roomie-action-menu__icon small`" />

      <span>{{ selectedChoice.name }}</span>

      <span class="roomie-icon roomie-action-menu__chevron">
        <ChevronUpIcon
          class="transition-all"
          :style="{
            transform: isOpen ? 'rotate(0)' : 'rotate(180deg)'
          }" />
      </span>
    </button>
    <div
      v-if="isOpen && !isInitiallyOpen"
      class="roomie-action-menu__content invisible md:visible">
      <div class="roomie-action-menu__title">
        <p class="roomie-action-menu__title-text">
          {{ title }}
        </p>
      </div>
      <div class="roomie-action-menu__items">
        <ul>
          <RoomieActionMenuOption
            v-for="item in items"
            :key="item.id"
            :selected-option="selectedChoice"
            :item-name="item.name"
            @toggle-select="toggleSelect(item)">
            <RoomieIcon
              v-if="item.icon"
              :icon-name="item.icon"
              :custom-styles="`roomie-action-menu__icon`" />
            <span class="roomie-action-menu__name">{{ item.name }}</span>
          </RoomieActionMenuOption>
        </ul>
      </div>
      <div class="roomie-action-menu__footer">
        <button
          class="roomie-action-menu__footer-button cta-2 text-primary-600"
          @click="toggleMenu">
          Cerrar
        </button>
      </div>
    </div>
    <RoomieOverlay
      v-if="isOpen"
      :custom-styles="`roomie-action-menu__overlay visible md:invisible`"
      @click.native="closeMenu">
      <div
        v-if="isOpen"
        class="roomie-action-menu__content">
        <div class="roomie-action-menu__title">
          <p class="roomie-action-menu__title-text">
            {{ title }}
          </p>
        </div>
        <div class="roomie-action-menu__items">
          <ul class="roomie-action-menu__list">
            <RoomieActionMenuOption
              v-for="item in items"
              :key="item.id"
              :selected-option="selectedChoice"
              :item-name="item.name"
              @toggle-select="toggleSelect(item)">
              <RoomieIcon
                v-if="item.icon"
                :icon-name="item.icon"
                :custom-styles="`roomie-action-menu__icon`" />
              <span class="roomie-action-menu__name">
                {{ item.name }}
              </span>
            </RoomieActionMenuOption>
          </ul>
        </div>
        <div class="roomie-action-menu__footer">
          <button
            class="roomie-action-menu__footer-button cta-2 text-pine-600"
            @click="toggleMenu">
            Cerrar
          </button>
        </div>
      </div>
    </RoomieOverlay>
  </div>
</template>

<script>
import RoomieOverlay from '../RoomieOverlay/index.vue'
import RoomieIcon from '../RoomieIcon/index.vue'
import RoomieActionMenuOption from '../RoomieActionMenuOption/index.vue'
import ChevronUpIcon from '../../assets/icons/chevron-up.svg'
import clickOutside from '../../directives/clickOutside'

export default {
  name: 'RoomieActionMenu',
  components: {
    RoomieIcon,
    RoomieActionMenuOption,
    RoomieOverlay,
    ChevronUpIcon,
  },
  directives: {
    clickOutside
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true,
    },
    defaultChoice: {
      type: Object,
      default: () => ({})
    },
    isInitiallyOpen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selectedChoice: this.defaultChoice || this.items[0],
      isOpen: this.isInitiallyOpen,
      visible: true
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      this.$emit('close')
    },
    toggleSelect(item) {
      this.selectedChoice = item
      this.$emit('toggle-action', item)
      this.$emit('selected', item.id)
      this.toggleMenu()
    },
    closeMenu() {
      this.isOpen = false
      this.$emit('close')
    },
    hideMenu() {
      this.isOpen = false
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
